export default __webpack_public_path__ + "static/media/instagram_logo.555959bb.svg";